import { ErrorComponent } from '@components/error'
import type { PageWithContext } from '@lib/utils/context'
import { useRouter } from 'next/router'

const NotFoundPage: PageWithContext = () => {
    const router = useRouter()

    return <ErrorComponent statusCode={404} asPath={router.asPath} />
}

export default NotFoundPage
